// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { animate, cancelAnimation } from '@progress/kendo-vue-animation';
import { classNames, isRtl, getTabIndex, templateRendering, getListeners, getTemplate } from '@progress/kendo-vue-common';
import { calculatePercentage, updateProgress, truncateNumber } from '../common/utils';
import { DEFAULT_ANIMATION_DURATION, NO_ANIMATION } from '../common/constants';
import { validatePackage } from '@progress/kendo-vue-common';
import { packageMetadata } from '../package-metadata'; // tslint:enable:max-line-length

var ProgressBar = {
  name: 'KendoProgressBar',
  props: {
    animation: {
      type: [Boolean, Object],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    reverse: {
      type: Boolean,
      default: false
    },
    label: String,
    labelRender: [String, Object, Function],
    labelVisible: {
      type: Boolean,
      default: true
    },
    labelPlacement: {
      type: String,
      default: undefined,
      validator: function validator(value) {
        return ['start', 'center', 'end'].includes(value);
      }
    },
    dir: {
      type: String,
      default: undefined
    },
    max: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
    orientation: {
      type: String,
      default: 'horizontal',
      validator: function validator(value) {
        return ['horizontal', 'vertical'].includes(value);
      }
    },
    tabIndex: Number,
    emptyStyle: Object,
    emptyClassName: String,
    progressStyle: Object,
    progressClassName: String
  },
  created: function created() {
    validatePackage(packageMetadata);
    this.currentDir = this.$props.dir;
  },
  mounted: function mounted() {
    this._progressStatus = this.v3 ? this.progressStatusRef : this.$refs.progressStatus;
    this._progressStatusWrap = this.v3 ? this.progressStatusWrapRef : this.$refs.progressStatusWrap;
    this.currentDir = this.$props.dir !== undefined ? this.$props.dir : isRtl(this.$el) ? 'rtl' : 'ltr';
    this.animationFrame = animate({
      duration: this.animationDuration,
      onStart: this.handleStart,
      onUpdate: this.handleUpdate,
      onEnd: this.handleEnd
    });
  },
  destroyed: !!gh ? undefined : function () {
    cancelAnimation(this.animationFrame);
  },
  // @ts-ignore
  unmounted: function unmounted() {
    cancelAnimation(this.animationFrame);
  },
  data: function data() {
    return {
      currentDir: undefined
    };
  },
  watch: {
    value: function value(_newValue, oldValue) {
      this.prevValue = oldValue;
      this.animationFrame = animate({
        duration: this.animationDuration,
        onStart: this.handleStart,
        onUpdate: this.handleUpdate,
        onEnd: this.handleEnd
      });
    }
  },
  computed: {
    wrapperClass: function wrapperClass() {
      var _a = this.$props,
          disabled = _a.disabled,
          reverse = _a.reverse,
          orientation = _a.orientation,
          value = _a.value;
      var isVertical = orientation === 'vertical';
      var indeterminateProp = value === null;
      return {
        'k-widget k-progressbar': true,
        'k-progressbar-horizontal': !isVertical,
        'k-progressbar-vertical': isVertical,
        'k-progressbar-reverse': reverse,
        'k-progressbar-indeterminate': indeterminateProp,
        'k-state-disabled': disabled
      };
    },
    isVertical: function isVertical() {
      return this.orientation === 'vertical';
    },
    animationDuration: function animationDuration() {
      var animation = this.$props.animation;
      return typeof animation !== 'boolean' && animation !== undefined ? animation.duration : animation ? DEFAULT_ANIMATION_DURATION : NO_ANIMATION;
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var _a = this.$props,
        disabled = _a.disabled,
        labelVisible = _a.labelVisible,
        labelPlacement = _a.labelPlacement,
        max = _a.max,
        min = _a.min,
        tabIndex = _a.tabIndex,
        emptyStyle = _a.emptyStyle,
        emptyClassName = _a.emptyClassName,
        progressStyle = _a.progressStyle,
        progressClassName = _a.progressClassName;
    var value = this.$props.value || 0;
    var indeterminateProp = this.$props.value === null;
    var formattedLabel = truncateNumber(value);
    var labelProps = {
      value: value
    };
    var label = this.$props.labelRender ? templateRendering.call(this, this.$props.labelRender, getListeners.call(this)) : undefined;
    var labelDefaultRendering = h('span', {
      'class': 'k-progress-status'
    }, formattedLabel);
    var toggleButtonRendering = getTemplate.call(this, {
      h: h,
      template: label,
      defaultRendering: labelDefaultRendering,
      additionalProps: labelProps
    });
    var renderLabel = labelVisible ? this.$props.label ? h("span", {
      "class": 'k-progress-status'
    }, [this.$props.label]) : toggleButtonRendering : undefined;
    var positionClasses = classNames('k-progress-status-wrap', {
      'k-progress-start': labelPlacement === 'start',
      'k-progress-center': labelPlacement === 'center',
      'k-progress-end': labelPlacement === 'end' || labelPlacement === undefined
    });
    return h("div", {
      "class": this.wrapperClass,
      dir: this.currentDir,
      attrs: this.v3 ? undefined : {
        dir: this.currentDir,
        tabindex: getTabIndex(tabIndex, disabled),
        role: 'progressbar',
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": indeterminateProp ? undefined : value,
        "aria-disabled": disabled
      },
      tabindex: getTabIndex(tabIndex, disabled),
      role: 'progressbar',
      "aria-valuemin": min,
      "aria-valuemax": max,
      "aria-valuenow": indeterminateProp ? undefined : value,
      "aria-disabled": disabled
    }, [h("span", {
      "class": positionClasses + (emptyClassName ? ' ' + emptyClassName : ''),
      style: emptyStyle
    }, [renderLabel]), h("div", {
      "class": 'k-state-selected',
      style: progressStyle,
      ref: this.v3 ? function (el) {
        _this.progressStatusRef = el;
      } : 'progressStatus'
    }, [h("span", {
      "class": positionClasses + (progressClassName ? ' ' + progressClassName : ''),
      ref: this.v3 ? function (el) {
        _this.progressStatusWrapRef = el;
      } : 'progressStatusWrap'
    }, [renderLabel])])]);
  },
  methods: {
    focus: function focus() {
      if (this.$el) {
        this.$el.focus();
      }
    },
    progressStatusElement: function progressStatusElement() {
      return this._progressStatus;
    },
    progressStatusWrapElement: function progressStatusWrapElement() {
      return this._progressStatusWrap;
    },
    handleStart: function handleStart() {
      var percentage = calculatePercentage(this.min, this.max, this.prevValue);
      updateProgress(this._progressStatus, this._progressStatusWrap, percentage, this.isVertical);
    },
    handleUpdate: function handleUpdate(progress) {
      var percentage = calculatePercentage(this.min, this.max, this.prevValue + (this.value - this.prevValue) * progress);
      updateProgress(this._progressStatus, this._progressStatusWrap, percentage, this.isVertical);
    },
    handleEnd: function handleEnd() {
      var percentage = calculatePercentage(this.min, this.max, this.value);
      updateProgress(this._progressStatus, this._progressStatusWrap, percentage, this.isVertical);
    }
  }
};
var ProgressBarVue3 = ProgressBar;
export { ProgressBar, ProgressBarVue3 };